import o from"styled-components";import{mq as i}from"../../shared/media-queries.js";const t=o.div`
  width: 100%;
  height: ${e=>e.height??1}rem;

  ${i(null,"tablet")} {
    ${e=>e.hideOnMobile&&"display: none;"}
  }

  ${i(null,"laptop")} {
    ${e=>e.hideOnDesktop&&"display: none;"}
  }
`;export{t as default};
